module.exports = "<div ng-class=\"['modal-wrapper', 'grid-noGutter', {opened: $ctrl.show}]\">\n  <div class=\"modal-window\">\n    <div class=\"close-icon margin-n padder\" ng-click=\"$ctrl.close()\">\n      <i class=\"material-icons md-22\">close</i>\n    </div>\n    <div class=\"modal-content\" ng-transclude></div>\n    <!-- .modal-content END -->\n  </div>\n  <!-- .modal-window END -->\n  <div class=\"modal-overlay\" ng-click=\"$ctrl.close()\"></div>\n</div>\n  <!-- .modal-wrapper END -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpModal/adpModal.html
// module id = 735
// module chunks = 0